import "./svg/one-half.svg"

export default {
    name: "one-half",
    viewBox: "266 245",
}
